<template>
  <button
    class="tw-h-max tw-rounded-md tw-p-1 focus:tw-outline-none"
    :class="[
      {
        '!tw-cursor-wait': form.processing,
      },
      limitHit
        ? '!tw-cursor-not-allowed tw-opacity-50'
        : 'focus:tw-ring focus:tw-ring-neutral-200',
    ]"
    :tabindex="limitHit ? -1 : 1"
    @click="pinReview"
    v-tooltip="limitHit ? 'You\'ve reached limit (3)' : ''"
  >
    <StarIcon
      class="tw-h-4 tw-w-4 tw-transition-colors"
      :class="[
        isPinned
          ? 'tw-fill-current tw-text-neutral-900 hover:tw-text-neutral-700'
          : 'tw-stroke-current tw-text-neutral-400 hover:tw-text-neutral-500',
      ]"
    />
  </button>
</template>

<script setup>
import StarIcon from '@/assets/images/icons/star-1.svg'
import { useForm } from '@inertiajs/vue3'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'
import { computed, inject } from 'vue'

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  isPinned: {
    type: Boolean,
    default: false,
  },
  path: {
    type: String,
    required: true,
  },
})

const { accessControl } = usePermissionSystem()
const form = useForm({})
const removeReviewFromFavorites = inject('removeReviewFromFavorites')
const addReviewToFavorites = inject('addReviewToFavorites')

const limitHit = computed(() => {
  return (
    accessControl.value.subscription.privileges.favoritedReviews.limitHit &&
    !props.isPinned
  )
})

const pinReview = () => {
  if (form.processing || limitHit.value) {
    return
  }

  const options = {
    preserveScroll: true,
    only: ['mentor', 'errors', 'isFavoriteReviewsLimitHit', 'currentUser'],
  }

  if (props.isPinned) {
    form.delete(props.path, {
      ...options,
      onSuccess: () => {
        removeReviewFromFavorites(props.id)
      },
    })
  } else {
    form.post(props.path, {
      ...options,
      onSuccess: () => {
        addReviewToFavorites(props.id)
      },
    })
  }
}
</script>
